import { Injectable } from '@angular/core';
import { ApiService } from "../api/api.service";
import { Observable, BehaviorSubject } from "rxjs";
import { map, tap } from "rxjs/operators";

export interface AiSettingsConfig {
  summary: boolean;
  support: boolean;
  pulse_summary?: boolean;
}

export interface AiSettingsResponse {
  uid?: string;
  config: AiSettingsConfig;
}

export interface AiSettingsApiResponse {
  data: {
    ai_settings: AiSettingsConfig;
  };
  status_message: string;
  message: string | null;
}

export interface AiSettingsUpdatePayload {
  ai_settings: AiSettingsConfig;
}

@Injectable({
  providedIn: 'root'
})
export class AiSettingsService {
  private aiSettingsSubject = new BehaviorSubject<AiSettingsResponse | null>(null);
  public aiSettings$ = this.aiSettingsSubject.asObservable();

  constructor(
    private api: ApiService,
  ) { }

  getAiSettings(): Observable<AiSettingsResponse> {
    return this.api.get('organisation/ai_settings').pipe(
      map((response: AiSettingsApiResponse) => {
        return {
          config: response.data.ai_settings
        };
      }),
      tap((settings: AiSettingsResponse) => {
        this.aiSettingsSubject.next(settings);
      })
    );
  }

  updateAiSettings(aiSettings: AiSettingsConfig): Observable<AiSettingsResponse> {
    const payload: AiSettingsUpdatePayload = {
      ai_settings: aiSettings
    };

    return this.api.put('organisation/ai_settings', payload).pipe(
      map((response: AiSettingsApiResponse) => {
        return {
          config: response.data.ai_settings
        };
      }),
      tap((settings: AiSettingsResponse) => {
        this.aiSettingsSubject.next(settings);
      })
    );
  }
}
